<template>
    <div class="referrals">
        <List v-if="client_id" :DB="list" @emit="emit" />
        <component v-if="component" :is="component" :item="item" @emit="emit" />
    </div>
</template>

<script>

import List from '../components/List.vue';
import WebSoc from '../utils/WebSoc.js'
import { format } from 'date-fns';
import { mapActions } from 'vuex';
import editMember from '../components/editMember';
import referActivity from '../components/referActivity';

export default {
    components: {
        List,
        editMember,
        referActivity
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        customers () { return this.$store.state.DB.customers }
    },
    data () {
        return {
            component: '',
            item: false,
            list: { 
                t: 'refer-list',
                DB: 'refer-links',
                dbClient_id: '',
                local: true,
                storeDB: true,
                title: 'Referrals',
                fields: [
                    { title: 'Created', field: 'created', width: 200, map: item => format(item.created,'dd/MM/yy HH:mm') },
                    { title: 'Member', class: 'td-ulb', field: 'customer_id', width: 220, map: item => {  
                        var customer = this.customers.find(c => c._id == item.customer_id); return customer ? customer.name : 'no name';
                    } },
                    { title: 'Refer Code', field: 'id', width: 130, class: 'ta-r' },
                    { title: 'Landed', field: 'landed', width: 90, class: 'td-ulb ta-r', width: 90, type: 'num' },
                    { title: 'Joined', field: 'joined', width: 90, class: 'td-ulb ta-r', width: 90, type: 'num' },
                    { title: 'Active', field: 'lands', width: 290, class: 'ta-r', map: item => {
                        var lands = item.lands;
                        if ( !Array.isArray(lands) || lands.length == 0 ) return '';
                        if ( lands.length == 1 ) return format(lands[0],'dd/MM/yy HH:mm');
                        return format(lands[0],'dd/MM/yy HH:mm') + ' - ' + format(lands[lands.length-1],'dd/MM/yy HH:mm')
                    }}
                ],
                filter: { client_id: '', landed: { $gt: 0 } },
            }            
        }
    },
    created () {
        this.list.filter.client_id = this.client_id;
        console.log('Referrals',JSON.parse(JSON.stringify(this.list.filter)));
    },
    mounted () {
        
    },
    methods: {
        showMember ( refer ) {
            console.log('showMember refer',refer);
            WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id: refer.customer_id },customer => {
                this.item = customer;
                this.component = 'editMember';
            })
        },
        showActivity ( refer  ) {
            this.item = refer;
            this.component = 'referActivity';
        },
        'refer-list' ({ action, field, item, value, e }) {
            switch ( field.field ) {
                case 'name':
                case 'customer_id': return this.showMember(item);
                case 'landed':
                case 'joined': return this.showActivity(item);    
            }
            console.log('what refer-list',field);
        },
        emit ( data ) {
            if ( data.action == 'exit' ) {
                this.component = '';
                this.item = false
            }

            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
        },
        ...mapActions([
            'getCustomerName'
        ])
    }
}    
</script>